<div class="my-container">
  <ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: true }"></ngx-loading>
</div>

<div class="login-background" appNoAutocomplete>
  <div class="row tac m0">
    <form #loginForm="ngForm">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 tac" style="margin-top: 15%;">        
        <h1 class="ncd-main-text">NCD</h1>
      </div>
      <div class="col-xs-12" style="margin: 5px 0;">
        <mat-form-field class="login-width">
          <mat-icon matPrefix [ngStyle]="{ color: 'grey' }">person</mat-icon>
          <input
            matInput
            name="username"
            id="username"
            [(ngModel)]="loginObjform.username"
            required
            maxlength="20"
            placeholder="Username"
            #username
            #usernameValue="ngModel"
            onkeypress="if(this.value.length >= this.getAttribute('maxlength'))  return false;"
          />
        </mat-form-field>
        <div
          class="error fs12 fntr marginLeftpc15 pull-left"
          *ngIf="usernameValue.invalid && (usernameValue.dirty || usernameValue.touched)"
        >
          <span class="error fntr fs12" *ngIf="usernameValue?.errors.required"> This field is required. </span>
        </div>
      </div>
      <div class="col-xs-12" style="margin: 5px 0;">
        <mat-form-field class="login-width">
          <mat-icon matPrefix [ngStyle]="{ color: 'grey' }">lock</mat-icon>
          <input
            matInput
            name="password"
            id="password"
            [type]="hidePassword ? 'text' : 'password'"
            [(ngModel)]="loginObjform.password"
            required
            minlength="8"
            maxlength="15"
            placeholder="Password"
            #passwordValue="ngModel"
            onkeypress="if(this.value.length >= this.getAttribute('maxlength'))  return false;"
          />
          <mat-icon
            class="cursorPointer"
            [ngStyle]="{ color: 'grey' }"
            (click)="hidePassword = !hidePassword"
            matSuffix
          >
            {{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon
          >
        </mat-form-field>
        <div
          class="error fs12 fntr marginLeftpc15 pull-left"
          *ngIf="passwordValue.invalid && (passwordValue.dirty || passwordValue.touched)"
        >
          <span class="error fntr fs12" *ngIf="passwordValue?.errors.required"> This field is required. </span>
        </div>
      </div>
      <div class="col-xs-12" style="margin: 5px 0;">
        <div class="login-width img-container" style="background-color: #ffffff;">
          <img class="pull-left m5 captcha-image" alt="captcha" [src]="base64Image" id="captcha" height="40" />
          <mat-form-field class="captcha">
            <input
              matInput
              name="captchaInput"
              id="captchaInput"
              [(ngModel)]="loginObjform.captcha"
              class="pl10"
              placeholder="Enter code"
              #captcha="ngModel"
              maxlength="5"
              required
              (keyup.enter)="validateForm()"
              onkeypress="if(this.value.length >= this.getAttribute('maxlength'))  return false;"
            />
          </mat-form-field>
          <mat-icon [ngStyle]="{ color: 'grey' }" class="pull-right mt13 cursorPointer" (click)="reloadCaptchaImage()"
            >refresh</mat-icon
          >
        </div>
      </div>

      <div class="col-xs-12" style="margin: 5px 0;">
        <div
          class="error fs12 fntr marginLeftpc15 pull-left"
          *ngIf="captcha.invalid && (captcha.dirty || captcha.touched)"
        >
          <span class="error fntr fs12" *ngIf="captcha?.errors.required"> This field is required. </span>
          <span class="error fntr fs12" *ngIf="captcha?.errors.isInvalid">
            Captcha is invalid. Please try again.
          </span>
        </div>
      </div>

      <div class="col-xs-12" style="margin: 5px 0;">
        <button
          type="submit"
          class="btn btn-primary login-button"
          name="submit1"
          (keyup.enter)="validateForm()"
          (click)="validateForm()"
        >
          LOGIN
        </button>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" (click)="resetPassword()">
        <a class="btn forgotPassLink">Reset Password ?</a>
      </div>
    </form>
    <div
      class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
      style="margin: 5px 0; bottom: 0;"
      (click)="navigateToPrivacyPage()"
    >
      <a class="btn forgotPassLink privacy-policy-link">Privacy Policy</a>
    </div>
  </div>
</div>
